import { ArcElement, Chart, DoughnutController, Legend, Tooltip } from 'chart.js';

// Register plugins
Chart.register(DoughnutController, ArcElement, Tooltip, Legend);
// @ts-expect-error Chart is valid
window.Chart = Chart;
